import {
  QUERY_KEY_MANAGEMENT_SEARCH_UNITS,
  QUERY_KEY_MANAGEMENT_SEARCH_UNITS_COUNT,
  QUERY_KEY_MANAGEMENT_SEARCH_UNITS_INFINITE
} from '@apps-common/apis/management/unit'
import {
  QUERY_KEY_PORTAL_SEARCH_UNITS,
  QUERY_KEY_PORTAL_SEARCH_UNITS_COUNT,
  QUERY_KEY_PORTAL_SEARCH_UNITS_INFINITE
} from '@apps-common/apis/portal/unit'
import {
  QUERY_GET_UNIT_ACTIVATION_BY_ID,
  QUERY_SEARCH_UNIT_ACTIVATIONS,
  QUERY_SEARCH_UNIT_ACTIVATIONS_INFINITE
} from '@apps-common/apis/portal/unit-activations'
import { queryClient } from '@apps-common/lib'

export const invalidateActivationQueries = (unitActivationRequestId?: number) => {
  queryClient.refetchQueries({ queryKey: QUERY_GET_UNIT_ACTIVATION_BY_ID(unitActivationRequestId) })
  queryClient.invalidateQueries({ queryKey: QUERY_SEARCH_UNIT_ACTIVATIONS() })
  queryClient.refetchQueries({ queryKey: QUERY_SEARCH_UNIT_ACTIVATIONS_INFINITE() })

  // invalidate all unit search queries

  // portal
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_PORTAL_SEARCH_UNITS_COUNT() })
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_PORTAL_SEARCH_UNITS_INFINITE() })
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_PORTAL_SEARCH_UNITS() })

  // management
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_MANAGEMENT_SEARCH_UNITS_COUNT() })
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_MANAGEMENT_SEARCH_UNITS_INFINITE() })
  queryClient.invalidateQueries({ queryKey: QUERY_KEY_MANAGEMENT_SEARCH_UNITS() })
}
